export default "__VITE_PUBLIC_ASSET__f3e7dfeb__"